/** @format */

import { Box, Paper, Typography } from '@mui/material';
import { flexRender } from '@tanstack/react-table';

export default function TableHeader({ headerGroups }) {
  return (
    <Paper component="thead" elevation={6} sx={{ p: 1 }}>
      {headerGroups.map((headerGroup) => {
        return (
          <Box component="tr" key={headerGroup.id}>
            {headerGroup.headers.map((header) => (
              <Typography
                component="th"
                key={header.id}
                sx={{ fontSize: '0.8rem', p: 1 }}
              >
                {header.isPlaceholder
                  ? null
                  : flexRender(
                      header.column.columnDef.header,
                      header.getContext()
                    )}
              </Typography>
            ))}
          </Box>
        );
      })}
    </Paper>
  );
}
